import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e29eb996"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sale-hours" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Rapport salgtimer", -1))
const _hoisted_3 = { class: "form-field" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Fra dato", -1))
const _hoisted_5 = { class: "form-field" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Til dato", -1))
const _hoisted_7 = { class: "form-field exclude-categories" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Ekskluder kategorier", -1))
const _hoisted_9 = { class: "exclude-weborders" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ekskluder webordre", -1))
const _hoisted_12 = { class: "submit" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Hent data", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsNav = _resolveComponent("StatisticsNav")!
  const _component_ValidationFormErrors = _resolveComponent("ValidationFormErrors")!
  const _component_CategorySelect = _resolveComponent("CategorySelect")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_BarChart = _resolveComponent("BarChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_StatisticsNav),
    _hoisted_2,
    _createVNode(_component_ValidationFormErrors, {
      errors: _ctx.form.errors
    }, null, 8, ["errors"]),
    _createVNode(_component_Card, { class: "filter-form-card" }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          class: "filter-form",
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.date_from) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.date_from]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.date_to) = $event))
            }, null, 512), [
              [_vModelText, _ctx.form.date_to]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_CategorySelect, {
              modelValue: _ctx.form.exclude_categories,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.exclude_categories) = $event)),
              categories: _ctx.categories
            }, null, 8, ["modelValue", "categories"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("label", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.exclude_web_orders) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.exclude_web_orders]
              ]),
              _hoisted_11
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Button, {
              color: "green",
              class: "submit__button",
              type: "submit"
            }, {
              default: _withCtx(() => [
                (_ctx.form.processing)
                  ? (_openBlock(), _createBlock(_component_SvgIcon, {
                      key: 0,
                      class: "loading-icon",
                      type: "mdi",
                      path: _ctx.icons.loading
                    }, null, 8, ["path"]))
                  : _createCommentVNode("", true),
                _hoisted_13
              ]),
              _: 1
            })
          ])
        ], 32)
      ]),
      _: 1
    }),
    (_ctx.data)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "chart-card"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_BarChart, {
              class: "chart",
              "chart-data": _ctx.chartData,
              options: _ctx.chartOptions
            }, null, 8, ["chart-data", "options"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}